/**
 * Date utility functions for the delivery system
 */

// Format date for display (YYYY-MM-DD)
export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

// Format date for API with proper time (ISO format) - Fixed version
export const formatDateForAPI = (date) => {
    try {
        if (!date) return null;

        // Convert to Date object if it's a string or date object
        const jsDate = date instanceof Date ? new Date(date.getTime()) : new Date(date);

        // Check if date is valid
        if (isNaN(jsDate.getTime())) {
            console.warn('Invalid date detected:', date);
            return null;
        }

        jsDate.setHours(9); // Set to 9am
        jsDate.setMinutes(0);
        jsDate.setSeconds(0);
        return jsDate.toISOString();
    } catch (error) {
        console.error('Error formatting date for API:', error, date);
        return null;
    }
};

// Get number of days in a month
export const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
};

// Check if date is today or in the past
export const isDateTodayOrPast = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    return checkDate <= today;
};

// Get month name
export const getMonthName = (year, month) => {
    return new Date(year, month).toLocaleDateString('default', { month: 'long' });
};

// Calculate the difference in months between two dates (for relative month calculation)
export const getMonthDifference = (startDate, targetDate) => {
    const start = new Date(startDate);
    const target = new Date(targetDate);

    return (
        (target.getFullYear() - start.getFullYear()) * 12 +
        (target.getMonth() - start.getMonth())
    );
};

// Calculate the difference in days between two dates
export const getDayDifference = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);

    const diffTime = end.getTime() - start.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

// Adjust date for month end if needed
export const adjustForMonthEnd = (year, month, day) => {
    const daysInMonth = getDaysInMonth(year, month);
    return Math.min(day, daysInMonth);
};

// Adjust date for weekends if needed
export const adjustForWeekends = (date) => {
    const dayOfWeek = date.getDay();
    let newDate = new Date(date);

    if (dayOfWeek === 0) { // Sunday
        newDate.setDate(date.getDate() + 1); // Move to Monday
    } else if (dayOfWeek === 6) { // Saturday
        newDate.setDate(date.getDate() + 2); // Move to Monday
    }

    return newDate;
};

// Constants for calendar
export const DAYS_OF_WEEK = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
export const CELL_SIZE = '32px';
export const CELL_SPACING = '16px';
export const NON_EMPTY_CELL_SCALE = 1.4;
export const MODAL_BORDER_RADIUS = '12px';